export const DamageTypes = [
  { value: 'dent', label: 'Dent' },
  { value: 'dent_smart_repair', label: 'Dent Smart Repair' },
  { value: 'scratch', label: 'Scratch' },
  { value: 'scratch_smart_repair', label: 'Scratch Smart Repair' },
  { value: 'chip', label: 'Chip' },
  { value: 'chips', label: 'Chips' },
  { value: 'paint_off_colour', label: 'Paint Off Colour' },
  { value: 'paint_previous_repair', label: 'Paint Previous Repair' },
  { value: 'rust', label: 'Rust' },
  { value: 'scuff', label: 'Scuff' },
  { value: 'broken_element', label: 'Broken Element' },
  { value: 'wheel_damage', label: 'Wheel Damage' },
  { value: 'other', label: 'Other' },
];

export const DamageTypesName = DamageTypes.reduce((acc, current) => {
  acc[current.value.toUpperCase()] = current.label;
  return acc;
}, {});
